import React, { Component } from "react";
import { firebaseDb } from "../../../shared/Firebase";
import Grid from "material-ui/Grid";
import Typography from 'material-ui/Typography';
import Paper from "material-ui/Paper";


class NewsContent extends Component {
  constructor() {
    super();
    this.state = { news: [] };
  }

  componentWillMount() {
    const blendRef = firebaseDb.ref("news/").orderByKey();
    let _this = this;

    const newsRef = blendRef.on("value", function(snapshot) {
      const news = snapshot.val();
      _this.setState({
        news: news
      });
    });
  }

  render() {
    const classes = this.props.classes;
    const news = this.state.news;
    const menu = Object.keys(news).reverse().map(key => {
      return (
        <Grid item xs={12} key={key}>
          <Paper className={classes.Card}>
            <ul className={classes.content}>
              <li>
                <Typography component="h1" className={classes.date}>
                  {news[key].date}
                </Typography>
                <Typography className={classes.title}>
                  {news[key].title}
                </Typography>
                <Typography className={classes.subTitle} component="p">
                    {news[key].subTitle}
                </Typography>
                <Typography component="p">
                  {news[key].description}
                </Typography>

              </li>
            </ul>
          </Paper>
        </Grid>
      );
    });
    return (
      <div className={classes.wrapper}>
            <div>{menu}</div>
      </div>
    );
  }
}

export default NewsContent;



// WEBPACK FOOTER //
// ./src/frontend/client/news/components/Card.js